import PropTypes from "prop-types";
import { t } from "@/i18n-js/instance";
import { useBookmarks } from "@/react/components/Spaces/Bookmarks/hooks/useBookmarks";
import { ConfirmationModal } from "@circle-react-shared/ModalsV2/ConfirmationModal";

export const DeleteBookmarkConfirmation = ({
  isOpen,
  onClose,
  bookmark,
  space,
}) => {
  const { deleteBookmark, isDeleting } = useBookmarks({ space, bookmark });

  return (
    <ConfirmationModal
      isOpen={isOpen}
      title={t("spaces.bookmarks.delete_bookmark", {
        display_type: bookmark.display_type,
      })}
      onClose={onClose}
      onCancel={onClose}
      onConfirm={deleteBookmark}
      cancelText={t("cancel")}
      confirmText={isDeleting ? t("deleting") : t("delete")}
      disabled={isDeleting}
      confirmVariant="danger"
    >
      {t("spaces.bookmarks.delete_confirm", {
        display_type: bookmark.display_type,
        name: bookmark.name,
      })}
    </ConfirmationModal>
  );
};

DeleteBookmarkConfirmation.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  bookmark: PropTypes.object.isRequired,
  space: PropTypes.object.isRequired,
};
